/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./RoutedMessagesSidebar.vue?vue&type=template&id=e6bec286"
import script from "./RoutedMessagesSidebar.vue?vue&type=script&lang=js"
export * from "./RoutedMessagesSidebar.vue?vue&type=script&lang=js"
import style0 from "./RoutedMessagesSidebar.vue?vue&type=style&index=0&id=e6bec286&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6bec286')) {
      api.createRecord('e6bec286', component.options)
    } else {
      api.reload('e6bec286', component.options)
    }
    module.hot.accept("./RoutedMessagesSidebar.vue?vue&type=template&id=e6bec286", function () {
      api.rerender('e6bec286', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/routedMessages/RoutedMessagesSidebar.vue"
export default component.exports